<template>
  <div >
    <nav-header v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag" v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <div class="center">
      <div class="navbar2">
        <div class="navbar-left-container2" v-if="!providerId">
          <img src="../../assets/logo.png" height="41" width="135" @click="toHome" class="search-icon" alt="">
        </div>
        <div :class="['navbar-right-container2', providerId?'navbar-search-pro':'']">
          <div class="search-bar clearfix">
            <input class="search-input"
                   type="text"
                   placeholder="搜索商品..."
                   v-model="selectName"
                   @keyup.enter="search">
            <!-- v-on:input="inputKey" -->
            <button class="search-btn" @click="search">搜索</button>
            <img src="../../../static/search.png" class="search-icon" alt="">
            <img src="../../../static/close.png" v-if="selectName" class="close_icon" alt="" @click="clearKey">
          </div>
        </div>
      </div>
    </div>

    <nav-bread v-if="!providerId">
      <!-- <span slot="goods">全部商品</span> -->
      <div class="nav-breadcrumb-wrap">
        <div class="cont">
          <div class="fican"><img src="../../assets/dh.png" />  全部商品分类
          </div>
          <ul class="homenav">
            <li :class='{on:"/"===$route.path}' @click="homepage">
              首页
            </li>
            <!--<li :class='{on:"/inspection"===$route.path}' @click="inspection">检验所-->
            <!--</li>-->
            <!-- <li :class='{on:"/vendor"===$route.path}' @click="vendor">厂商
            </li> -->
          </ul>
        </div>

      </div>
    </nav-bread>


    <div class="accessory-result-page accessory-page">
      <div class="container">
        <!-- 排序 -->
        <div class="filter-nav">
          <!--搜索-->
          <!--<div class="search hidden-md-and-down">-->
          <!--<el-input-->
          <!--placeholder="请输入内容"-->
          <!--v-model="name"-->
          <!--clearable-->
          <!--v-on:clear="clearKey"-->
          <!--v-on:input="inputKey"-->
          <!--&gt;-->
          <!--</el-input>-->
          <!--</div>-->
          <!--<div class="search_btn hidden-md-and-down">-->
          <!--<el-button icon="el-icon-search" plain @click="search">搜索</el-button>-->
          <!--</div>-->
          <div class="sort" >
            <!-- 面包屑导航 -->
            <span class="sortBrain">
              <el-breadcrumb separator-class="el-icon-arrow-right" class="brain" v-model="brave_name"  >
                <el-breadcrumb-item>
                    <span class="as"   @click="allGoods">全部商品</span>
                  </el-breadcrumb-item>
                <el-breadcrumb-item >{{brave_name}}</el-breadcrumb-item>
              </el-breadcrumb>
            </span>

            <!--排序-->
            <span class="sortby">排序:</span>
            <!--<a href="javascript:void(0)" class="default" v-bind:class="{'cur':saleFalg}" @click="salesGoods">销量</a>-->
            <a href="javascript:void(0)" class="price" v-bind:class="{'cur':!saleFalg}" @click="sortGoods">
              价格
              <span v-if="!saleFalg">
                                    <span class='el-icon-caret-bottom' v-if="!sortFlag"></span>
                                    <span class='el-icon-caret-top' v-else></span>
                                </span>
            </a>
            <a href="javascript:void(0)" class="filterby stopPop" @click="showPriceFilter">分类</a>

          </div>
        </div>
        <!-- 排序，搜索结果 -->
        <div class="accessory-result">
          <!-- 价格过滤filter / 商品列表侧边栏-->
          <div class="filter stopPop" id="filter" v-bind:class="{'filterby-show':filterBy}"  >
            <div id="fild" :class="fildFixed === true? 'isFixed' :''">
              <!-- 一级分类 -->
              <dl class="filter-price" v-for="item in categoryList">
                <dt>{{item.name}}</dt>
                <!-- 全部 -->
                <dd class="dd-all">
                  <span class="dd-four">|</span>
                  <a href="javascript:void(0)" class="all"  @click="setSortFilter(item.id,item.name)" v-bind:class="{'cur':sortChecked==item.id }">全部</a>
                </dd>
                <!-- 二级分类 -->
                <dd class="dd-two" v-for="(item1,index1) in item.child" >
                  <!--<a href="javascript:void(0)" @click="setSortFilter(item1.id)" v-bind:class="{'cur':sortChecked==item1.id}" >{{item1.name}}</a>-->
                  <!-- 三级分类 -->
                  <li class="dd-three">
                <dd v-for="(item2,index2) in item1.child">|
                  <a href="javascript:void(0)" @click="setSortFilter(item2.id,item2.name)" v-bind:class="{'cur':sortChecked==item2.id }" >{{item2.name}}</a>
                </dd>
                </li>
                </dd>
              </dl>
            </div>

          </div>
          <!-- search result accessories list 搜索、分类结果列表展示-->
          <div class="accessory-list-wrap">
            <div class="accessory-list col-5">
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="30">
                <li v-for="(item,index) in goodsList" :key="index" @click="todetection(item.id,item.remark)">
                  <div class="pic">
                    <a href="javascript:;"><img :src="item.img" alt=""></a>
                  </div>
                  <div class="main">
                    <div class="name">{{item.itemName}}</div>
                    <div class="money">
                      <span class="price">￥{{item.groupPrice || item.price}}</span>
                      <span class="originalPrice">￥{{item.originalPrice}}</span>
                    </div>
                    <div class="area">{{item.providerArea}} | {{item.providerName}}</div>
                    <!--<div class="area">月销{{item.sales}}件</div>-->
                    <!--<div class="btn-area">-->
                    <!--<a href="javascript:;" class="btn btn&#45;&#45;m" @click="addCart(item.productId)">加入购物车</a>-->
                    <!--</div>-->
                  </div>
                </li>
              </ul>

              <div class="f_tip" v-if="goodsList.length == 0" style="margin-top:150px;font-size: 14px;">搜索完成，没有结果</div>
              <div class="f_tip" v-else-if="!hasMoreData">---已经到底啦---</div>
              <!--&lt;!&ndash;加上滚动加载的div&ndash;&gt;-->
              <!--<div class="load-more" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="30">-->
              <!--&lt;!&ndash;加载中...&ndash;&gt;-->
              <!--<img src="./../assets/loading-spinning-bubbles.svg" v-show="hasMoreData">-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="md-overlay" v-show="overLayFlag" @click="closePop"></div>
    <!--<div>{{msg}}</div>-->

    <modal v-bind:c_mdshow='p_mdshow' v-on:c_close='p_close'>
      <p slot="msg">
        请先登录,否则无法加入到购物车!
      </p>
      <div slot='btnGroup'>
        <a href="javascript:;" class = 'btn btn--m' @click='p_mdshow=false'>关闭</a>
      </div>
    </modal>

    <modal v-bind:c_mdshow='p_mdshowCart' v-on:c_close='p_close'>
      <p slot="msg">
        <a href="javascipt:;" class="checkbox-btn item-check-btn check">
          <svg class="icon icon-ok">
            <use xlink:href="#icon-ok"></use>
          </svg>
        </a>
        <span>加入购物车成功</span>
      </p>
      <div slot='btnGroup'>
        <a href="javascript:;" class = 'btn btn--m' @click='p_mdshowCart=false'>继续购物</a>
        <router-link href="javascript:;" class='btn btn--m' to='/cart'>查看购物车</router-link>
      </div>
    </modal>
    <nav-footer></nav-footer>

    <!--底部导航-->
    <tabbar class="mobile" :selected="selected" :tabs='tabs'></tabbar>
  </div>
</template>

<script>
  import '../../assets/css/base.css'
  import '@/assets/css/product.css'
  // import  './../assets/css/bootstrap.min.css'
  import "@/assets/css/index.css?version=1.0.1";
  import NavHeader from '@/components/Header.vue'
  import NavFooter from '@/components/Footer.vue'
  import Tabbar from '@/components/Tabbar.vue'
  // import NavBread from '@/components/Bread.vue'
  import Modal from '@/components/Modal.vue'
  import "@/assets/css/login.css"
  import {
    getCookie
  } from "../../util/util";

  import axios from 'axios'

  export default {
    name: "GoodsList",
    data() {
      return {
        //                msg:'',
        goodsList: [],
        categoryList: [],

        sortChecked: this.$route.query.id ? this.$route.query.id : '', //分类默认高亮显示all
        saleSort: 0, //销量
        saleFalg: true,

        filterBy: false,
        overLayFlag: false,

        sortFlag: true, //默认是升序
        priceSortOrder: "",

        page: 1,
        limit: 10,

        loading: false,
        hasMoreData: true,

        p_mdshow: false,
        p_mdshowCart: false,
        fildFixed:false,
        handshow:false,

        // id:this.$route.query.id ? this.$route.query.id : null,
        selectName: this.$route.query.params,
        p_showSearch: false,
        p_loginModalFlag: false,
        brave_name:this.$route.query.name ? this.$route.query.name : '',
        // filterFixed:false
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || '',
        selected: '',
        tabs: [
          require("@/assets/hose_Filled.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_grey.png")
        ],
        title: '',
        keywords: '',
        description: ''
      }

    },
    metaInfo () {
      return {
        title: this.title,
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.keywords },
          { vmid: 'description', name: 'description', content: this.description }
        ]
      }
    },
    components: {
      NavHeader,
      NavFooter,
      // NavBread,
      Modal,
      Tabbar
    },
    watch: {
      sortChecked: {
        immediate: true,
        handler: function(val) {
          if (val === 6) {
            //疫情产品
            this.title = '新冠疫情产品_检验网-专业医学检验一站式服务平台'
            this.keywords = '新冠病毒 新冠检测 核酸检测 新冠病毒检测 新冠病毒核酸检测 个人新冠 企业新冠 个人新冠检测 企业新冠检测 医疗机构新冠检测'
            this.description = '检验网提供权威临床级新冠病毒核酸检测服务,提供个人新冠检测服务,企业新冠检测服务,医疗机构新冠检测服务等.'
          } else if (val === 5) {
            //妇幼健康
            this.title = '妇幼健康产品_检验网-专业医学检验一站式服务平台'
            this.keywords = 'HPV基因检测 HPV病毒检测 宫颈癌基因检测 乳腺癌基因检测 DNA检测 不育不孕检测  染色体畸变检测 孕前基因检测 遗传基因检测 妇女健康检测 新生儿健康检测 幼儿健康检测'
            this.description = '检验网提供权威临床级妇幼健康检验检测服务,提供各类妇女新生幼儿健康检验检测产品和服务,HPV基因检测,DNA检测,新生幼儿健康检测等.'
          } else if (val === 11) {
            //优健康
            this.title = '优健康产品_检验网-专业医学检验一站式服务平台'
            this.keywords = '酒精代谢检验检测 酒精代谢基因检测 肥胖基因检测 高血压基因检测 H型高血压基因检测'
            this.description = '检验网提供权威临床级和消费级各类基因检验检测服务,提供酒精代谢 肥胖 高血压 H型高血压等基因检验检测服务和产品.'
          } else if (val === 9) {
            //肿瘤检测
            this.title = '肿瘤检测产品_检验网-专业医学检验一站式服务平台'
            this.keywords = '肿瘤检测 肿瘤预防 癌症筛查 癌症检测 肺癌检测 肝癌检测 大肠癌筛查 结肠癌检测 直肠癌检测 胃癌检测 乳腺癌筛查 宫颈癌筛查'
            this.description = '检验网提供权威临床级各类肿瘤癌症筛查和检验检测服务,提供肺癌,大肠癌,胃癌,乳腺癌等各类肿瘤和癌症检验检测服务等.'
          } else {
            this.title = '检验网_基因检测检验网-专业医学检验一站式服务平台'
            this.keywords = '检验网 医学检验网 基因检验检测 新冠病毒检验检测 核酸检测 肿瘤检验检测 HPV检验检测 乳腺癌检验检测 高分子诊断'
            this.description = '检验网是中国领先的医学检验综合服务平台,精选中国临床级基因检验检测项目和服务,轻松医检就上jianyanwang.com!'
          }
        }
      }
    },
    mounted() {
      // console.log(this.$route.query.id)
      // console.log(this.$route.query.name)
      this.getCategoryList();
      this.getGoodsList(this.sortChecked == "" ? null : this.sortChecked);
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {  window.removeEventListener('scroll', this.handleScroll)
    },
    directives:{
      trigger:{

        inserted(el,binging){

            el.click()

        }
      }
    },
    methods: {

      homepage() {
        this.$router.replace("/")
      },
      inspection() {
        this.$router.replace("/inspection")
      },
      vendor() {
        this.$router.replace("/Vendor")
      },
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },
      // 侧边栏固定定位
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        let offsetTop = document.querySelector('#fild').offsetTop
        if(offsetTop >= 100) {
          this.fildFixed = scrollTop > (offsetTop- 100)
        }
      },


      //跳转到详情页
      todetection(id, remark) {
        const { href } = this.$router.resolve({
          path: "detection",
          query: {
            id: id,
            remark: remark
          }
        })
        window.open(href, '_blank')
        // this.$router.push({
        //   path: "detection",
        //   query: {
        //     id: id,
        //     remark: remark
        //   }
        // })
      },
      //获取类目/分类列表
      getCategoryList() {
        // axios.defaults.baseURL = 'http://192.168.15.23:8080'
        axios.get("/jys/category/p?shopId=" + this.providerId).then((res) => {
          // axios.defaults.baseURL = process.env.API_ROOT
          this.categoryList = res.data.list;
        })
      },

      //商品列表
      getGoodsList(id) {
        this.loading = true
        axios.get("jys/item/all?shopId=" + this.providerId, {
          params: {
            page: this.page,
            limit: this.limit,
            categoryId: id,
            name: this.selectName,
            priceSortOrder: this.priceSortOrder,
            platform: 1,
            saleSort: this.saleSort
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token") ? getCookie("_token") : ""
          }
        }).then((res) => {
          var goodsListTem = this.goodsList
          if (res.data.code == 0) {
            if (this.page == 1) {
              goodsListTem = []
            }

            //新版
            var goodsList = res.data.itemPage.list

            if (goodsList.length < this.limit) {
              this.goodsList = goodsListTem.concat(goodsList)
              this.loading = true
              this.hasMoreData = false
            } else {
              this.goodsList = goodsListTem.concat(goodsList)
              this.loading = false
              this.hasMoreData = true
              this.page = this.page + 1
            }
          }

        })
      },
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },
      toCart(){
        if(getCookie("_token")){
          this.$router.push("/cart")
        }else{
          this.$message.error("您还没有登录哦")
          this.$emit("showLoginModal")
        }
      },
      //销量
      salesGoods() {
        this.saleFalg = true;
        this.page = 1;
        this.saleSort = 1;
        this.priceSortOrder = "";
        this.getGoodsList(this.sortChecked == "" ? null : this.sortChecked);
      },
      toHome(){
        this.$router.push("/")
      },
      //商品价格排序
      sortGoods() {
        this.saleFalg = false;
        this.sortFlag = !this.sortFlag;
        this.priceSortOrder = this.sortFlag ? "asc" : "desc";
        this.saleSort = 0;
        this.page = 1;
        this.getGoodsList(this.sortChecked == "" ? null : this.sortChecked);
      },

      //鼠标滚动时需要加载的方法
      loadMore() {
        console.log("LoadMore_goods")
        // this.page ++
        this.getGoodsList(this.sortChecked == "" ? null : this.sortChecked)
      },
      clearKey() {
        this.selectName = ""
        this.page = 1
        this.getGoodsList(this.sortChecked == "" ? null : this.sortChecked)
      },
      // 搜索
      search() {
        this.page = 1
        this.getGoodsList(this.sortChecked == "" ? null : this.sortChecked)
        // inputKey() {
        if (this.selectName.length == 0) {
          this.page = 1
          this.getGoodsList(this.sortChecked == "" ? null : this.sortChecked)
        }
        // },
      },

      //显示价格过滤和遮罩
      showPriceFilter() {
        this.filterBy = true;
        this.overLayFlag = true;
      },

      //关闭价格过滤和遮罩
      closePop() {
        this.filterBy = false;
        this.overLayFlag = false;
      },

      //设置点击分類某一项,显示满足对应价格区间的商品,并关闭遮罩和价格过滤的方法
      // setSortFilter(){
      //   this.sortChecked="all";
      //   this.page = 1;
      //   this.getGoodsList(null);
      //   this.closePop();
      // },
      setSortFilter(id,name) {
        if (id) {
          this.sortChecked = id;
          this.page = 1;
          this.getGoodsList(id);
          this.closePop();
          this.brave_name = name
        } else {
          this.sortChecked = "";
          this.page = 1;
          this.getGoodsList(null);
          this.closePop();
        }

      },

      p_close() {
        this.p_mdshow = false;
        this.p_mdshowCart = false
      },
      allGoods() {
        this.brave_name=''
        this.setSortFilter()
      }

    }
  }
</script>

<style scoped>
  .nav-breadcrumb a {
    color: #999;
  }

  .nav-breadcrumb .allgoods {
    color: #00C5B0;
  }

  .load-more {
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .sort-up {
    transform: rotate(180deg);
    transition: all .5s ease-out;
  }

  .search,
  .sort {
    width: 100%;
    float: right;
  }
  .sort{
    margin-right: 14%;
  }

  .search {
    width: 40%;
    text-align: left;
  }

  .search_btn {
    width: 10%;
    float: left;
    text-align: center;

  }

  .el-input--small .el-input__inner {
    width: 100%;
    height: 40px;
    /*line-height: 40px;*/
  }

  .el-button--small,
  .el-button--small.is-round {
    height: 40px;
  }

  /*搜索框*/
  .search-bar {
    width: 294px;
    height: 40px;
  }

  .search-bar .search-input {
    width: 781px;
    height: 40px;
    font-size: 14px;
    margin: 0;
    border-right: none;
    position: absolute;
    top: 20px;
    left: -20px;
    border-radius: 5px 0 0 5px;
    padding: 0 40px;
  }

  .search-bar .search-btn {
    width: 87px;
    background-color: #00C5B0;
    color: #ffffff;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    border-left: none;
    border-radius: 0 5px 5px 0;
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .search-bar .search-icon {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 33px;
    left: 0px;
  }

  .search-bar .close_icon {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 33px;
    right: 15%;
  }

  .f_tip {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }

  .navbar-right-container2 {
    width: 868px;
    margin: 0 auto;
    position: relative;
  }

  .navigation[data-v-7d4308f8] {
    display: none;
  }

  .navbar-left-container2 {
    width: 200px;
    position: absolute;
    left: 67px;
    top: 20px;
  }

  .navbar2 {
    max-width: 100%;
    position: relative;

  }
  .as  {
    cursor: pointer;
  }
  .mobile{
    display: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .mobile{
      display: block;
    }
    .navbar-right-container2 {
      width: 266px;
      margin: 0 0 0 120px;
    }
    .navbar-left-container2 {
      left: 30px;
    }
    .navbar-left-container2 img {
      width: 90px;
      height: 27px;
      margin-top: 6px;
    }
    .search-bar .close_icon {
      right: 43%;
    }
    .search-bar .search-icon{
      left: 14px;
    }
    .search-bar .search-input {
      width: 173px;
      left: 0;
    }
    .navbar-cart-container {
      margin-right: 0;
    }
    .search-bar .search-input {
      width: 181px;
    }
    /deep/ .more{
      display: none;
    }
    .filter dd a{
      border-bottom: none;
    }
    .md-change-login {
      height: 40px;
      display: flex;
      width:inherit;
      justify-content:space-around;
      font-size: 20px;
    }
    .md-change-login a{
      width: 30%;font-size: 14px;
      line-height: 40px;
    }
    .regi_form_input{
      width: 310px;
    }
    .btn-code{
      font-size: 12px;
      width: 21%;
      bottom: 15px;
    }
    /*.center {*/
      /*margin-bottom: 40px;*/
    /*}*/
    .container{
      width: 100%!important;
    }

    .navbar-search-pro{
      margin-left: 60px !important;
    }
  }

  .md-change-login {
    height: 40px;
    display: flex;
    width:inherit;
    justify-content:space-around;
    font-size: 20px;
  }
  .md-change-login a{
    width: 30%;font-size: 14px;
    line-height: 40px;
  }
  .regi_form_input{
    width: 310px;
  }
  .btn-code{
    font-size: 12px;
    width: 21%;
    bottom: 15px;
  }
  /*.center {*/
    /*margin-bottom: 40px;*/
  /*}*/
  .container {
    margin:0;
    width: 100%;
  }
  #fild.isFixed{
    position: fixed;
    top: 120px;
    margin-right: 25px;
    z-index: 999;
    box-sizing: border-box;
    transition: right .5s ease-out;
  }

  .filter {
    width: 215px;
    height: 100%;
    padding-top: 10px;
    margin-right: 15px;
    margin-top: -75px;
    margin-left: -8px;
  }
  #fild {
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    padding: 20px;
    margin-left: -20px;
    width: 215px;
  }

  .filter dt{
    margin-bottom: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
    font-size: 15px;
    font-weight: 700;
  }
  .filter dd {
    display: inline-block;
    padding: 5px;
    margin: 5px 0 0 0;
  }
  .filter dd a  {
    display: inline;
  }
  .filter .dd-two {
    display: inline-block;
    font-size: 13px;
    font-weight: 700;
  }
  .filter .dd-three {
    list-style: none;
    font-weight: 400;
    font-size: 12px;
  }
  .filter .dd-three dd {
    padding: 3px;

  }
  .filter .filter-price dd .cur {
    font-weight: inherit;
  }
  .brain-nav {
    list-style: none;
    display: block;
  }
  .filter-nav {
    margin-bottom: 0;
  }

  .accessory-list .main .area {
    height: 1.5em
  }
  .center {
    margin-bottom: 0;
  }
  .originalPrice{
    text-decoration: line-through;
  }
  .cont {
    margin: 0 auto;
    height: 32px;
  }


  .fican {
    background: #00C4AA;
    float: left;
    width: 220px;
    height: 32px;
    color: #fff;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    position: relative;
  }

  .fican img {
    vertical-align: middle;
  }
  .homenav {
    float: left;
    line-height: 32px;
    margin-left: 30px;
    cursor: pointer;
  }

  .homenav li {
    text-align: center;
    float: left;
    font-weight: bold;
    width: 80px;
  }

  .homenav li a {
    display: block;
  }
  .accessory-result .filter {
    margin-right: 0;
  }
  .filter dl {
    margin-bottom: 0;
  }
  .accessory-result .accessory-list-wrap{
    margin-left: 115px;
    /* margin-right: 235px; */
  }
  .accessory-result .accessory-list-wrap {
    flex: 0.8;
    margin-top: 20px;min-height: 560px;
  }
  .accessory-list .main .name {
    height: 2.65em;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .cont {
    background-color: #F5F5F5;
  }
  .accessory-list .pic {
    max-width: 176px;
    height: 176px;
    margin: 0 auto;
  }
  @media only screen and (min-width: 167px) and (max-width: 1256px) {
      .search-bar .search-input{
          width:550px;left: 264px;
      }
      .search-bar .search-icon {
          left: 276px;
      }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .accessory-list .pic {
      width: 110px;
      height: 110px;
      margin: 0 auto;
    }
    .sortBrain {
      display: none;
    }
    .navbar-right-container2 {
      width: 266px;
      margin: 0 0 0 120px;
    }
    .navbar-left-container2 {
      left: 30px;
    }
    .navbar-left-container2 img {
      width: 90px;
      height: 27px;
      margin-top: 6px;
    }
    .search-bar .close_icon {
      right: 43%;
    }
    .search-bar .search-icon{
      left: 14px;
    }
    .search-bar .search-input {
      width: 173px;
      left: 0;
    }
    .navbar-cart-container {
      margin-right: 0;
    }
    .search-bar .search-input {
      width: 181px;
    }
    /deep/ .more{
      display: none;
    }
    .filter dd a{
      border-bottom: none;
    }
    .md-change-login {
      height: 40px;
      display: flex;
      width:inherit;
      justify-content:space-around;
      font-size: 20px;
    }
    .md-change-login a{
      width: 30%;font-size: 14px;
      line-height: 40px;
    }
    .regi_form_input{
      width: 310px;
    }
    .btn-code{
      font-size: 12px;
      width: 21%;
      bottom: 15px;
    }
    /*.center {*/
      /*margin-bottom: 40px;*/
    /*}*/

    .accessory-result {
      width: 100%;
    }
    .accessory-result {
      display: flex;
    }
    .accessory-result .accessory-list-wrap {
      flex:1;
      margin-top: 20px;
      margin-bottom: 55px;
      margin-left: 0;
    }
    .filter {
      width: 215px;
      height: 110%;
      padding-top: 10px;
      margin-right: 15px;
      margin-top: -30px;
      margin-left: -8px;
    }
    #fild {
      padding: 20px;
      margin-left: -20px;
      width: 255px;
      border: none;
    }
    .sort{
    margin-right: 0;
}
  }
  .all {
    /* color: #00C5B0;      */
    font-size: 12px;
    margin-left: -1px;
  }
  .dd-four {
     font-size: 12px;
     margin-left: 3px;
  }
  .dd-all {
    display: inline-block;
    font-weight: 400;
  }
  .sortBrain {
    position: absolute;
    left: 272px;
    top: 138px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/goods/GoodsList.vue